import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'EditDescriptionDialogController',
            EditDescriptionDialogController
        );

    /** @ngInject */
    function EditDescriptionDialogController(
        $scope,
        $state,
        CompaniesFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;
        var companyId;

        init();

        function init() {
            companyId = $scope.ngDialogData.company;

            vm.issue = angular.copy($scope.ngDialogData.issue);
            vm.save = save;
        }

        function save() {
            CompaniesFactory.editIssue(companyId, vm.issue.id, {
                description: vm.issue.description,
            }).then(function () {
                toastr.success('Zapisano');
                ngDialog.close();
                $state.reload('company_employee.issue_list.details');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/edit-description/edit-description.controller.ts